import { useContext, useEffect, useState } from 'react';
import StandardRapport from '../../../_StandardRapport/StandardRapport';
import { rapportInfos } from '../../../_Common/Const/RapportInfo';
import EDCheckbox from '../../../../../BaseComponents/Checkboxes/EDCheckbox';
import EDDatePicker from '../../../../../BaseComponents/DatePicker/EDDatePicker';
import EDDivider from '../../../../../BaseComponents/Divider/EDDivider';
import EDGrid from '../../../../../BaseComponents/GridComponents/EDGrid';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { RapportQuery } from '../../../_StandardRapport/Queries/RapportQuery/RapportQuery';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import {
  RapportSettings,
  useReadRapportSettings,
  useWriteRapportSettings,
} from '../../../_StandardRapport/StandardRapportSettings';
import {
  booleanToString,
  stringToBoolean,
} from '../../../../../Utils/Formatters/Utils/ValueUtils';
const Forsamlingsstatistik = () => {
  const rapport = rapportInfos.BOForsamlingsstatistik;
  const userSettings = useReadRapportSettings(rapport.rapportID);
  const doWriteUserSettings = useWriteRapportSettings(rapport.rapportID);

  const [datumFr, setDatumFr] = useState('');
  const [datumTi, setDatumTi] = useState('');
  const [isValidDateFr, setIsValidDateFr] = useState(true);
  const [isValidDateTi, setIsValidDateTi] = useState(true);
  const [preliminara, setPreliminara] = useState(false);
  const [exporterade, setExporterade] = useState(false);
  const [plats, setPlats] = useState(true);
  const [verksamhetstyper, setVerksamhetstyper] = useState(true);
  const [aldersindelning, setAldersindelning] = useState(true);
  const [begravningsordning, setBegravningsordning] = useState(false);
  const [veckodag, setVeckodag] = useState(false);

  useEffect(() => {
    setPreliminara(stringToBoolean(userSettings['preliminara'], false));
    setExporterade(stringToBoolean(userSettings['exporterade'], false));
    setPlats(stringToBoolean(userSettings['plats'], true));
    setVerksamhetstyper(
      stringToBoolean(userSettings['verksamhetstyper'], true)
    );
    setAldersindelning(stringToBoolean(userSettings['aldersindelning'], true));
    setBegravningsordning(
      stringToBoolean(userSettings['begravningsordning'], false)
    );
    setVeckodag(stringToBoolean(userSettings['veckodag'], false));
  }, [userSettings]);

  const writeUserSettings = () => {
    const settings: RapportSettings = {
      preliminara: booleanToString(preliminara),
      exporterade: booleanToString(exporterade),
      plats: booleanToString(plats),
      verksamhetstyper: booleanToString(verksamhetstyper),
      aldersindelning: booleanToString(aldersindelning),
      begravningsordning: booleanToString(begravningsordning),
      veckodag: booleanToString(veckodag),
    };
    doWriteUserSettings(settings);
  };

  const activeDatabaseContext = useContext(ActiveDatabaseContext);
  if (rapport && activeDatabaseContext.activeDatabase) {
    const ExporteraForsamlingsstatistik = () => {
      writeUserSettings();
      RapportQuery({
        db: activeDatabaseContext.activeDatabase || '',
        rapportId: rapport.rapportID,
        rapportParams: {
          FranDatum: datumFr !== '' ? datumFr : undefined,
          TillDatum: datumTi !== '' ? datumTi : undefined,
          InkluderaPrelbokade: preliminara ? 'Y' : undefined,
          EndastExporterade: exporterade ? 'Y' : undefined,
          VisaVerksamhetstyp: verksamhetstyper ? 'Y' : undefined,
          VisaPlatser: plats ? 'Y' : undefined,
          VisaBegravningsTyp: begravningsordning ? 'Y' : undefined,
          VisaAldersintervall: aldersindelning ? 'Y' : undefined,
          VisaBegravningarPerVeckodag: veckodag ? 'Y' : undefined,
        },
      });
    };

    return (
      <StandardRapport
        rapport={rapport}
        onExport={ExporteraForsamlingsstatistik}
        exportDisabled={
          datumFr === '' ||
          datumTi === '' ||
          datumFr > datumTi ||
          !isValidDateFr ||
          !isValidDateTi
        }
        exportDisabledReason={
          datumFr === '' || datumTi === ''
            ? 'Datum måste fyllas i'
            : datumFr > datumTi
            ? 'Tilldatum måste vara senare än fråndatum'
            : !isValidDateFr || !isValidDateTi
            ? 'Ogiltigt datum'
            : undefined
        }
      >
        <EDTypography variant="body2">Välj datumintervall:</EDTypography>
        <EDGrid container rowSpacing={-1}>
          <EDGrid item sm={6} xs={12}>
            <EDDatePicker
              label="Från datum"
              tooltip="Inkludera aktiviteter med startdatum från och med detta datum"
              value={datumFr}
              onDateChange={(newDate, isValid) => {
                setDatumFr(newDate);
                setIsValidDateFr(isValid);
              }}
              required
              allowOnlyNumbers
            />
            <EDTypography variant="caption" color="error" fontSize={'0.75rem'}>
              {datumFr && !isValidDateFr ? 'Valt datum är ogiltigt' : ''}
            </EDTypography>
          </EDGrid>
          <EDGrid item sm={6} xs={12}>
            <EDDatePicker
              label="Till datum"
              tooltip="Inkludera aktiviteter med startdatum till och med detta datum"
              value={datumTi}
              onDateChange={(newDate, isValid) => {
                setDatumTi(newDate);
                setIsValidDateTi(isValid);
              }}
              required
              allowOnlyNumbers
            />
            <EDTypography variant="caption" color="error" fontSize={'0.75rem'}>
              {datumTi && !isValidDateTi ? 'Valt datum är ogiltigt' : ''}
            </EDTypography>
          </EDGrid>
          <EDGrid item sm={6} xs={12}>
            <EDCheckbox
              label="Inkludera preliminära aktiviteter"
              tooltip="Inkludera preliminärbokade aktiviteter"
              checked={preliminara}
              onCheck={checked => setPreliminara(checked)}
            />
          </EDGrid>
          <EDGrid item sm={6} xs={12}>
            <EDCheckbox
              label="Endast exporterade aktiviteter"
              tooltip="Inkludera bara aktiviteter som har exporterats från Aveny till statistikdatabasen"
              checked={exporterade}
              onCheck={checked => setExporterade(checked)}
            />
          </EDGrid>
        </EDGrid>

        <EDDivider />
        <br />
        <EDTypography variant="body2">Inkludera följande:</EDTypography>
        <EDCheckbox
          label="Plats"
          tooltip="Summera statistiken per plats"
          checked={plats}
          onCheck={checked => setPlats(checked)}
        />
        <br />
        <EDCheckbox
          label="Verksamhetstyper"
          tooltip="Summera statistiken för övriga aktiviteter och lokaluthyrningar per verksamhetstyp"
          checked={verksamhetstyper}
          onCheck={checked => setVerksamhetstyper(checked)}
        />
        <br />
        <EDCheckbox
          label="Åldersindelning"
          tooltip="Summera statistiken per verksamhetstyp och åldersgrupp"
          checked={aldersindelning}
          onCheck={checked => setAldersindelning(checked)}
        />
        <br />
        <EDCheckbox
          label="Begravningsordning"
          tooltip="Summera statistiken för begravningar per begravningstyp (Svenska kyrkans ordning, Borgerlig, etc)"
          checked={begravningsordning}
          onCheck={checked => setBegravningsordning(checked)}
        />
        <br />
        <EDCheckbox
          label="Begravningar per veckodag"
          tooltip="Summera statistiken för begravningar per veckodag och starttid"
          checked={veckodag}
          onCheck={checked => setVeckodag(checked)}
        />
      </StandardRapport>
    );
  } else return <></>;
};
export default Forsamlingsstatistik;
